import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  display: inline-block;
`;

export const Tooltip = styled.div`
  position: absolute;
  left: 0;
  min-width: 200px;
  max-width: 300px;
  max-height: 200px;
  overflow-y: auto;
  padding: 8px 16px;

  font: ${(props) => props.theme.fonts.textBigMicroBold};
  color: ${(props) => props.theme.colors.greys.darkest};

  background-color: ${(props) => props.theme.colors.greys.lightest};
  border-radius: 4px;
  border: 1px solid ${(props) => props.theme.colors.greys.light};

  box-shadow: 0px 4px 8px 0px ${(props) => props.theme.colors.greys.light};
  z-index: 1;
`;

export const TooltipItem = styled.div`
  padding: 4px 0;

  &:not(:last-child) {
    border-bottom: 1px solid ${(props) => props.theme.colors.greys.light};
  }
`;
